import type { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TIMEZONE_NAME_OR_OFFSET } from '@ppl/utils/date.utils';
import type { Observable } from 'rxjs';


@Injectable()
export class TimezoneInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const reqWithTimezone = req.headers.has('Timezone')
      ? req
      : req.clone({ setHeaders: { Timezone: TIMEZONE_NAME_OR_OFFSET } });

    return next.handle(reqWithTimezone);
  }
}
